/**
 * Un texto opcional vacío (o con solo espacios, tabs o saltos de línea) viaja
 * como null, no como "": así queda NULL en la base, y dos registros sin ese dato
 * no chocan en un índice único (Postgres no hace chocar dos NULL; dos "" sí).
 * Lo usan las variables de alta y edición de los formularios generados
 * (get<X>CreateVariables, get<X>UpdateVariables) y los Input de las
 * subentidades (get<X>CreateInput, get<X>UpdateInput) para los textos opcionales.
 * Un texto con contenido va tal cual, sin recortar.
 */
export function blankToNull(value: string | null | undefined): string | null {
  if (typeof value !== "string") return value ?? null;
  return value.trim() === "" ? null : value;
}
